import * as angular from "angular";
import {IController} from "angular";

export class BringozStatusTagComponent implements IController {
  status: any;
  extraText: any;
  extraTooltipText: any;
  isSmall: any;
  isSecondary: boolean;


  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozStatusTag', {
    bindings: {
      status: '<',
      extraText: '<?',
      extraTooltipText: '<?',
      isSmall: '<?',
      isSecondary: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-status-tag/bringoz-status-tag.html',
    controller: BringozStatusTagComponent
  });
